import config from '@/config';
import { AuthService, Navigation, NewMainClient } from 'zr-arch';
import { container } from 'tsyringe';
import { Logout, PromptLogin } from '@/views';

export default class ApiService {
    private static _client: NewMainClient = NewMainClient.SecuredClient(
        config.Main.Host,
        async () => {
            await container.resolve(Navigation).redirectTo(PromptLogin, null);
        },
        async () => {
            await container.resolve(Navigation).redirectTo(Logout, null);
        }
    );

    // 不带认证拦截器的客户端，用于专家端（wxToken 鉴权，不需要 OIDC access_token）。
    // 避免 SecuredClient 的 authorizationHandler 发送 "Bearer undefined" 触发 401 跳转。
    private static _unsecured: NewMainClient = NewMainClient.UnsecuredClient(config.Main.Host);

    private get client(): NewMainClient {
        return ApiService._client;
    }

    private get unsecuredClient(): NewMainClient {
        return ApiService._unsecured;
    }

    async get(path: string, params?: Record<string, string>): Promise<any> {
        return await this.client.get(path, params);
    }

    async post(path: string, body?: any, queryParams?: Record<string, string>): Promise<any> {
        if (queryParams) {
            const qs = new URLSearchParams(queryParams as Record<string, string>);
            path += `?${qs.toString()}`;
        }
        return await this.client.post(path, body);
    }

    // 以下方法走 UnsecuredClient，不添加 Authorization 头。
    // 用于专家端 Input.vue（通过 wxToken query 参数鉴权，不需要 OIDC token）。
    async unsecuredGet(path: string, params?: Record<string, string>): Promise<any> {
        return await this.unsecuredClient.get(path, params);
    }

    async unsecuredPost(path: string, body?: any, queryParams?: Record<string, string>): Promise<any> {
        if (queryParams) {
            const qs = new URLSearchParams(queryParams as Record<string, string>);
            path += `?${qs.toString()}`;
        }
        return await this.unsecuredClient.post(path, body);
    }

    async getBlob(path: string, params?: Record<string, string>): Promise<Blob> {
        const token = await container.resolve<AuthService>(AuthService).getAccessToken();
        const qs = new URLSearchParams(params as Record<string, string>);
        const url = `${config.Main.Host}${path}?${qs.toString()}`;
        const response = await fetch(url, {
            headers: { Authorization: `Bearer ${token}` },
        });
        if (!response.ok) throw new Error(`导出失败: ${response.status}`);
        return await response.blob();
    }
}
